import _objectSpread from "/root/ONLINE_SERVICE/other/ferry/task_workspace/baidu/map-ai-native/feed-h5/node_modules/.pnpm/@babel+runtime@7.23.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.promise.finally.js";
import circleProgress from '../circleProgress.vue';
import { fetchData } from '../../../../utils';
import { getJsOnceToken, initParisInstance } from './initParisFactory';
import pageVisible from '@/pages/micro-detail/utils/pageVisibleEvent.js';
import { getParamsFromUrl, requestBdApi, compareSv } from '@baidu/map-fe-utils';
import md5 from 'js-md5';
const {
  c: city = '0',
  os = '',
  sv = '',
  cuid = '',
  abtest = '',
  source = '',
  uid = '',
  unique_id = ''
} = getParamsFromUrl();
let isCreated = false;
export default {
  name: 'time-task',
  components: {
    circleProgress
  },
  data() {
    return {
      currentTime: 0,
      duration: 15,
      // 总时长（秒）
      lastTime: 0,
      // 页面离开时进度时间（秒）
      isLottery: false,
      isLotterying: false,
      // 是否正在开奖中
      taskText: '',
      strokeWidth: 68,
      showTipImg: false,
      isLotteryFail: false,
      taskHasShow: false,
      isTaskDone: false,
      taskObj: {
        task_id: '',
        task_type: 0,
        task_total: 0,
        task_done_num: 0,
        day: '',
        finish: 1,
        browse_time: 0
      },
      isLogin: false,
      showTask: false,
      // 是否展示任务组件
      picUrl: 'https://map-mobile-lbsapp.cdn.bcebos.com/250328hb.png'
    };
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    isDark: {
      type: Boolean,
      default: false
    },
    tpSource: {
      type: String,
      default: ''
    },
    stdTag: {
      type: String,
      default: ''
    }
  },
  computed: {
    layerColor() {
      return this.isDark ? '#3c3c3c' : '#F2F4F7';
    },
    visiableLottery() {
      return this.isLottery || this.isLotteryFail;
    },
    imgBgStyle() {
      return {
        'background': `url(${this.picUrl})`,
        'background-size': 'cover',
        'background-repeat': 'no-repeat',
        'background-position': '50%'
      };
    },
    microBuryParams() {
      return {
        note_type: 'image',
        city_id: city,
        std_tag: this.stdTag,
        poi_uid: uid,
        tp: this.tpSource,
        uniqueid: unique_id,
        source
      };
    }
  },
  watch: {
    value(val) {
      if (val) {
        if (!this.isLogin) {
          return;
        }
        if (this.isLottery || this.isLotteryFail || this.showTipImg) {
          this.getTaskInit();
        }
        this.isLotteryFail = false;
      }
    }
  },
  methods: {
    // 开始播放
    start() {
      this.$nextTick(() => {
        var _this$$refs$progressR;
        (_this$$refs$progressR = this.$refs.progressRef) === null || _this$$refs$progressR === void 0 || _this$$refs$progressR.start();
      });
    },
    // 暂停播放
    pause() {
      var _this$$refs$progressR2, _this$$refs$progressR3;
      const {
        currentTime
      } = (_this$$refs$progressR2 = this.$refs.progressRef) === null || _this$$refs$progressR2 === void 0 ? void 0 : _this$$refs$progressR2.getProgressData();
      (_this$$refs$progressR3 = this.$refs.progressRef) === null || _this$$refs$progressR3 === void 0 || _this$$refs$progressR3.pause();
      // 正在抽奖中，并且未开启下次任务，lastTime设置为0，否则下次播放会从上次的15s剩余时间开始播放
      if (this.isLotterying) {
        this.lastTime = 0;
      } else {
        this.lastTime = Math.floor(currentTime);
      }
    },
    // 重置
    handleReset() {
      var _this$$refs$progressR4;
      // 设置进度条宽度为0，防止ios有小圆点
      this.strokeWidth = 0;
      this.currentTime = 0;
      (_this$$refs$progressR4 = this.$refs.progressRef) === null || _this$$refs$progressR4 === void 0 || _this$$refs$progressR4.reset();
      this.lastTime = 0;
    },
    // 完成回调
    onComplete() {
      if (this.isTaskDone) {
        return;
      }
      this.showTask && this.handleTimeEnd();
    },
    /**
     * 初始化任务
     */
    getTaskInit() {
      if (this.showTipImg) {
        setTimeout(() => {
          this.showTipImg = false;
        }, 500);
      }
      this.getTask();
      this.isLottery = false;
    },
    /**
     * 获取任务信息
     *
     * @returns 返回 Promise 对象，解析为任务信息对象
     */
    getTask() {
      const tokenCommonObj = this.getCommonToken({}, 'tzNW8faDDGTxOgl');
      const params = _objectSpread({
        source,
        from: 'post_detail_feed',
        city,
        os,
        sv
      }, tokenCommonObj);
      const url = '/feed-server/activity/task_init';
      return fetchData(url, {
        method: 'post',
        params
      }).then(res => {
        if (res.errno === 0) {
          const {
            is_progress = 0,
            // 0活动结束或者未开始，1活动进行中   int
            is_login = 0,
            // 1登录状态，0未登录状态   int
            task_id = 0,
            // 任务id   int64
            task_num = 0,
            // 当前正在进行第几个任务   int
            duration = 15,
            // 每1轮任务时长
            is_finish = 0,
            stop_text = '',
            login_text = '',
            pic_url = 'https://map-mobile-resource.cdn.bcebos.com/icon/service/search/default/getreward-2.png'
          } = res.data || {};
          this.duration = duration || 15;
          this.showTask = is_progress === 1;
          this.isLogin = is_login === 1;
          if (pic_url) {
            this.picUrl = pic_url;
          }
          if (this.showTask && !this.isLogin) {
            this.showTipImg = true;
          }
          this.taskObj = res.data;
          this.strokeWidth = 68;
          if (!this.isLogin) {
            this.taskText = login_text;
            this.strokeWidth = 0;
            return;
          }
          if (!this.taskHasShow) {
            this.taskHasShow = true;
            this.showHandle();
          }
          this.isLotterying = false;
          const isTaskDone = is_finish === 1;
          this.isTaskDone = isTaskDone;
          if (isTaskDone) {
            this.currentTime = 15;
            this.taskText = stop_text;
            this.start();
            return;
          }
          this.getTaskTime({
            taskId: task_id,
            roundId: task_num
          });
          // this.start();
        }
      }).catch(err => {
        // this.isLotteryFail = true;
        console.error(err, 'get task error');
      }).finally(() => {
        isCreated = false;
      });
    },
    /**
     * 记录浏览时长
     */
    saveTime({
      taskId,
      roundId,
      countTime
    }) {
      requestBdApi('bdapi://nativeTask', {
        action: 'write',
        taskId,
        roundId,
        countTime
      });
    },
    /**
     * 获取抽奖结果
     *
     * @returns 抽奖结果的Promise对象
     */
    getLottery() {
      const {
        task_id,
        task_date,
        task_num
      } = this.taskObj;
      return getJsOnceToken(3000).then(tokenObj => {
        const tokenCommonObj = this.getCommonToken(tokenObj, 'Y4dybcFbGAbLLqF', true);
        const params = _objectSpread({
          city: Number(city),
          os,
          sv,
          task_id,
          task_num,
          task_date,
          source,
          from: 'post_detail_feed'
        }, tokenCommonObj);
        const url = '/feed-server/activity/lottery_new';
        return fetchData(url, {
          method: 'post',
          params
        }).then(res => {
          let {
            data,
            errno
          } = res;
          if (errno === 0) {
            this.isLottery = true;
            if (data.award_text) {
              this.taskText = data.award_text;
            }
          } else {
            this.isLotteryFail = true;
            this.taskText = '发奖失败';
          }
          this.sendLog(['MCEDse.MCEDpoiugc.NewMedia.microDetail.timeballreward.show'], this.microBuryParams);
          return Promise.resolve(res);
        }).catch(err => {
          this.taskText = '发奖失败';
          this.isLotteryFail = true;
          console.error(err, 'error');
        });
      });
    },
    // 15s 任务完成，抽奖后重置进度条，重新开始计时
    handleTimeEnd() {
      this.isLotterying = true;
      this.getLottery().then(res => {
        setTimeout(() => {
          const {
            task_total,
            task_num,
            slide_text
          } = this.taskObj;
          this.updateFeedScrolled(false);
          if (task_total && task_num < task_total || this.isLotteryFail) {
            this.showTipImg = true;
            this.taskText = slide_text;
            this.handleReset();
          } else if (task_num === task_total) {
            this.getTaskInit();
          }
        }, 3000);
      });
    },
    // 生成token参数
    getCommonToken(tokenObj = {}, salt, isLottery = false) {
      const {
        jstoken = '',
        ztoken = '',
        oztoken = ''
      } = tokenObj;
      const t = Math.floor(Date.now() / 1000);
      const {
        task_id,
        task_date,
        task_num
      } = this.taskObj;
      let token = '';
      if (isLottery) {
        token = `city=${city}&cuid=${cuid}&task_date=${task_date}&task_id=${task_id}&task_num=${task_num}&timestamp=${t}${salt}`;
      } else {
        token = `cuid=${cuid}&timestamp=${t}${salt}`;
      }
      token = md5(token);
      return {
        cuid,
        token,
        jstoken,
        ztoken,
        oztoken,
        abtest,
        timestamp: t
      };
    },
    // 监听页面展示隐藏
    handleVisibilityChange() {
      pageVisible.on('page-show', () => {
        try {
          this.updateFeedScrolled(false);
          if (isCreated || this.isLottery || this.showTipImg || this.isLotterying) {
            isCreated = false;
            return;
          }
          this.getTaskInit();
        } catch (e) {
          console.error(e, 'circletask page-show error');
        }
      });
      pageVisible.on('page-hide', () => {
        try {
          this.pause();
          const {
            task_id,
            task_num
          } = this.taskObj;
          this.saveTime({
            taskId: task_id,
            roundId: task_num,
            countTime: this.lastTime
          });
          this.isLottery = false;
        } catch (e) {
          console.error(e, 'circletask page-hide error');
        }
      });
    },
    getTaskTime({
      taskId,
      roundId,
      callback = 'getTaskTimeCallback'
    }) {
      window[callback] = res => {
        const time = res || 0;
        this.currentTime = time;
        this.start();
      };
      requestBdApi('bdapi://nativeTask', {
        action: 'read',
        taskId,
        roundId,
        callback
      });
    },
    // 更新feed滚动状态
    updateFeedScrolled(newValue) {
      this.$emit('input', newValue);
    },
    /**
     * 点击任务按钮处理函数
     *
     * 添加点击行为日志，并跳转到百度地图的导航分享页面
     */
    clickTask() {
      this.sendLog(['MCEDse.MCEDpoiugc.NewMedia.microDetail.timeball.click'], this.microBuryParams);
      if (!this.isLogin) {
        window.taskLoginCallback = data => {
          if (+data) {
            this.isLogin = true;
            this.getTaskInit();
          }
        };
        this.$emit('clickTask', 'taskLoginCallback');
        return;
      }
      const {
        prize_url = ''
      } = this.taskObj;
      if (prize_url) {
        window.location.href = prize_url;
      }
    },
    showHandle() {
      this.$nextTick(() => {
        var _this$$refs;
        const obDom = (_this$$refs = this.$refs) === null || _this$$refs === void 0 || (_this$$refs = _this$$refs.progressRef) === null || _this$$refs === void 0 ? void 0 : _this$$refs.$el;
        if (!obDom) {
          return;
        }
        // 曝光埋点
        this.$io.observe(obDom, () => {
          this.sendLog(['MCEDpoiugc.NewMedia.microDetail.timeball.show'], this.microBuryParams);
        });
      });
    },
    // 发送日志
    sendLog(actionID, params) {
      if (!window.MapLogReport || !actionID) {
        console.warn('MapLogReport或actionID 不存在');
        return;
      }
      window.MapLogReport.send(_objectSpread({
        da_src: actionID
      }, params));
    }
  },
  async created() {
    // 判断版本号是否大于等于20.16.50，如果不是则不执行后续代码
    if (compareSv(sv || '0', '20.16.50') < 0) {
      return;
    }
    isCreated = true;
    initParisInstance();
    await this.getTask();
    this.showTask && this.handleVisibilityChange();
  }
};